import { Avatar, AvatarBadge } from "@chakra-ui/react";
import { ChatContext } from "providers/chat";
import { useContext } from "react";
import { AVATAR_URL } from "utils/constants";

const UserAvatar = ({
  user,
  size,
  mr = "0px",
  hideOnline,
}: {
  user: any;
  size: string;
  mr?: string;
  hideOnline?: boolean;
}) => {
  const { online } = useContext(ChatContext);
  return (
    <Avatar
      w={size}
      h={size}
      mr={mr}
      bg="#D9D9D9"
      src={user.avatar ? `${AVATAR_URL}${user.id}` : ""}
      name={`${user.first_name} ${user.last_name}`}
      title={`${user.first_name} ${user.last_name}`}
    >
      {online[user.id] && !hideOnline && (
        <AvatarBadge boxSize="1em" bg="green.500" top="0px" transform="translate(20%, -20%)" />
      )}
    </Avatar>
  );
};

export default UserAvatar;
